import { IkeFieldType } from '@ikegps/core-api';
import type { FormModelField } from '../../form/form.field';
import { CollectionModelField, ModelMutator } from '../collection.field';
import { registerFieldType } from './field.registry';

export class ModelMutatorText extends ModelMutator<FormModelField, CollectionModelFieldText> {
	manual(newText: string | null) {
		if (newText == null || newText.length === 0) {
			this.state.setFieldValue(this.field.id, null);
		} else {
			this.state.setFieldValue(this.field.id, newText);
		}
	}

	override copy(from: CollectionModelFieldText): boolean {
		// Cannot use super.copy. See TODO above
		this.manual(from.value);
		return true;
	}
}
export class CollectionModelFieldText extends CollectionModelField<FormModelField, string> {
	static TYPE: IkeFieldType = IkeFieldType.TEXT;
	static isTextField(f: CollectionModelField): f is CollectionModelFieldText {
		return f.schema.type === CollectionModelFieldText.TYPE;
	}

	private _Mutator: ModelMutatorText = new ModelMutatorText(this);
	get Mutator() {
		if (this._Mutator == null) {
			this._Mutator = new ModelMutatorText(this);
		}
		return this._Mutator;
	}

	override get value() {
		return this.stateValue || '';
	}

	override get displayValue() {
		const stateValue = this.stateValue;
		if (stateValue == null) {
			return '';
		}
		return stateValue || '';
	}

	hasValue() {
		const value = this.value;
		if (value == null || value === '') {
			return false;
		}
		return true;
	}
}

registerFieldType(IkeFieldType.TEXT, (parent, schema) => new CollectionModelFieldText(parent, schema));
